import request from '../../untils/request';

export function electricDataComprehensiveQuery(data) {
  return request({
    url: '/realData/electricDataComprehensiveQuery',
    method: 'get',
    params: data,
  });
}
export function waterDataComprehensiveQuery(data) {
  return request({
    url: '/realDataWater/waterDataComprehensiveQuery',
    method: 'get',
    params: data,
  });
}

// 获取商户名称下拉列表
export function selectListLesseeName(data) {
  return request({
    url: '/lessee/selectList',
    method: 'get',
    params: data,
  });
}